export const KeyIcon = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3.509 7.558A6.31 6.31 0 0 1 9.842 6l3.925-3.917c.283-.291.842-.466 1.242-.408l1.816.25c.6.083 1.159.65 1.25 1.25l.25 1.817c.059.4-.133.958-.408 1.241L14 10.15c.667 2.167.15 4.625-1.566 6.333-2.459 2.459-6.45 2.459-8.917 0a6.315 6.315 0 0 1-.008-8.925m10.75-2.133-1.917-1.917"
      stroke="#0e966f"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.917 10.833a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
      stroke="#0e966f"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
